export default {
    newDesign: true,
    parameters: {
        landing_id: "LatQuFTSc",
        segment: 14,
    },
    title:
        "¡Responde 9 preguntas y recibe una clase gratuita para tu niño o niña! | Kodland",
    downtimeUrl: "https://www.kodland.org/es",
    startPage: {
        title:
            "¡Responde 9 preguntas y recibe una clase gratuita para tu niño o niña!",
        subtitle: "¡Todo adaptado a su edad y ritmo de aprendizaje!",
        image: {
            url: "/welcome/latam_5_7_new_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/latam_5_7_new_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Empezar el quiz 🚀",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "¡Gracias por confiar en nuestra plataforma educativa!",
        subtitle:
            "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
    },
    customStopPages: {
        child: {
            title:
                "Lamentablemente, solo un padre o tutor puede inscribir a un estudiante en las clases.",
            subtitle:
                "Si quieres continuar, puedes compartir este enlace con tus padres.<br>¡Ojalá podamos verte pronto en nuestras clases! ",
            image: "/welcome/quizV2/child-parent.png",
        },
    },
    quizRotateBySteps: {
        1: {
            question: "¿Eres mamá, papá, otro familiar o hijo/a?",
            answers: [
                "👨‍👩‍👧 Padre / madre / tutor",
                {
                    answer: "👦👧Niño / niña",
                    stopAnswer: true,
                    customStopPageId: "child",
                },

            ],
        },
        2: {
            question: "¿Tu hijo o hija ha tomado clases en línea antes?",
            answers: [
                "👨‍💻 Sí, de forma regular",
                "⏳ Sí, solo una vez o por poco tiempo",
                "✨ No, todavía no",
            ],
        },
        3: {
            question:
                "¿Qué tipo de actividades disfruta más tu hijo o hija?",
            answers: [
                "🎨 Dibujar, colorear o hacer manualidades",
                "🧩 Resolver rompecabezas o construir con bloques",
                "🎮 Jugar en la tablet o en la computadora",
                "📖 Inventar historias o imaginar nuevos mundos",
                "🎵 Cantar, bailar o hacer música",
                "🌳 Explorar la naturaleza y descubrir cómo funcionan las cosas",
            ],
        },
        4: {
            title: "¿Qué edad tiene tu hijo o hija?",
            type: "age",
            button: "",
        },
        5: {
            question: "¿Cómo crees que reaccionaría tu hijo o hija si le propusieras una clase de programación de prueba?",
            answers: [
                "🤩 Muestra interés en la programación",
                "🤔 No le interesa, pero podría aceptar probar",
                "🎨 Preferiría otras actividades (deporte, arte, etc.)",
                "🙅‍♂️ Diría que no quiere hacerlo",
            ],
        },
        6: {
            question: "¿Tienen una computadora o laptop que tu hijo o hija pueda usar para las clases?",
            answers: [
                "💻 Sí",
                {
                    answer: "😐 No",
                    stopAnswer: true
                },
            ],
        },
        7: {
            question: "¿Te gustaría que tu hijo o hija…",
            subtitle: "(elige lo que suena más emocionante)",
            answers: [
                "🎮 Cree su primer videojuego",
                "🎨 Diseñe su propio dibujo animado o caricatura",
                "💻 Aprenda a programar juegos y proyectos simples",
                "🧱 Diseñe en 3D y construya mundos creativos",
                "🌈 Aprenda jugando y creando",
                "✨ ¡De todo un poco!",
            ],
        },
        8: {
            question: "Qué presupuesto mensual te parece razonable para la educación de tu hijo o hija?",
            financial: true,
            answers: [
                "🌱 Hasta 30 USD",
                "🌿 30–60 USD",
                "🌳 60–100 USD",
                "🚀 Más de 100 USD",
            ],
        },
        9: {
            question: "¿Cuánto solías gastar al mes en actividades extracurriculares para tu hijo o hija?",
            answers: [
                "⚪ No gastábamos nada",
                "💸 20–50 USD",
                "💳 50–100 USD",
                "💎 Más de 100 USD"
            ],
        },

        10: {
            title: "🎉 ¡Solo un paso más!",
            typeInfo: "congrats",
            subtitle:
                "Ayuda a tu hijo a explorar su lado creativo con programación y diseño digital.<br>🌟 Ya son más de 200.000 niños creando y aprendiendo con nosotros.",
            button: "📅 ¡Reserva una clase gratis!",
        },
        11: {
            title: "Reserva una clase gratuita",
            type: "one-page-contacts",
            subtitle: "",
            button: "Casi terminamos 🔥",
        },
        12: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        13: {
            title: "Revisa estos detalles para completar el registro ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
            button: "¿Qué más?",
        },
        14: {
            title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
            typeInfo: "whatsapp",
            subtitle:
                "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
            button: "¿Qué más?",
        },
        15: {
            title: "La clase se realizará en nuestra plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
            button: "Entendido ✅",
        },
    },
};
